import React from 'react';

import o5 from '../images/o5.jpg';
import o1 from '../images/o1.jpg';

const marqueeItems = [
    'Wedding Cards', '◆',
    'Visiting Cards', '◆',
    'Bill Books', '◆',
    'Stamps', '◆',
    'Leaflets', '◆',
    'Standees & Flex', '◆',
    'Personalised Gifts', '◆',
    'Offset Printing', '◆',
];

function HomeSection() {
    return (
        <section className="bd-hero" id="hero">
            <div className="bd-hero__glyph" aria-hidden>R</div>

            <div className="bd-hero__inner">
                <div className="bd-pill">
                    <span className="bd-pill__dot" />
                    Open · Mon–Sat 9:30 to 8 · Raja Park, Jaipur
                </div>

                <h1 className="bd-hero__h1">
                    We Print<br />
                    <em>everything.</em>
                </h1>

                <div className="bd-hero__row">
                    <p className="bd-hero__lede">
                        Four decades of putting ink to paper for Jaipur — wedding cards, bill books,
                        visiting cards, stamps, banners, and a thousand quiet things in between.{' '}
                        <em>Bring us the brief.</em>
                    </p>
                    <div className="bd-hero__ctas">
                        <a
                            href="https://wa.me/919413341382"
                            className="bd-btn bd-btn--accent bd-btn--block"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <span>Request a quote</span>
                            <span aria-hidden>→</span>
                        </a>
                        <a
                            href="https://wa.me/919413341382"
                            className="bd-btn bd-btn--ghost bd-btn--block"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <span>WhatsApp us now</span>
                            <span aria-hidden>↗</span>
                        </a>
                    </div>
                </div>

                <div className="bd-hero__strip">
                    <div className="bd-photo">
                        <img src={o5} alt="Wedding card spread" />
                    </div>
                    <div className="bd-stat-card">
                        <div className="bd-stat-card__label">Since 1981</div>
                        <div>
                            <div className="bd-stat-card__num">
                                40<sup>+ yr</sup>
                            </div>
                            <div className="bd-stat-card__line">
                                Three generations behind the press.
                            </div>
                        </div>
                    </div>
                    <div className="bd-photo">
                        <img src={o1} alt="Stack of stamps" />
                    </div>
                </div>
            </div>

            <div className="bd-marquee" aria-hidden>
                <div className="bd-marquee__track">
                    {marqueeItems.concat(marqueeItems).map((s, i) => (
                        <span
                            key={i}
                            className={s === '◆' ? 'bd-marquee__diamond' : ''}
                        >
                            {s}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default HomeSection;
